const ALLOWED_ROLES = ["backoffice", "BU", "backoffice:developer"];

type OidcProfile = Record<string, unknown> | undefined;

export function getUserRoles(profile: OidcProfile): string[] {
  const roles = profile?.roles;

  if (!roles) {
    return [];
  }

  if (Array.isArray(roles)) {
    return roles.map(String);
  }

  return [String(roles)];
}

export function hasBackofficeRole(profile: OidcProfile): boolean {
  const userRoles = getUserRoles(profile);

  return userRoles.some((role) => ALLOWED_ROLES.includes(role));
}
